<template>
  <q-card flat>
    <q-card-section class="no-padding">
      <q-banner class="bg-blue text-white" inline-actions>
        {{ title }} <span dir="ltr">{{ startDate }} - {{ endDate }}</span>
        <template v-slot:action>
          <q-btn flat icon="close" v-close-popup round/>
        </template>
      </q-banner>
    </q-card-section>
    <q-card-section id="chart">
      <div class="row full-width">
        <div class="col-md-6 col-xs-12 col-sm-12">
          <apexchart height="450" weight="500" type="donut" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div class="col-md-6 col-xs-12 col-sm-12">
          <q-card flat>
            <q-card-section>
              <q-table
                  dense
                  flat
                  row-key="Group_ID"
                  :rows-per-page-options="[0]"
                  hide-pagination
                  :data="lodash.orderBy(items, ['Group_Name'],['asc'])">
                <template v-slot:header>
                  <q-tr class="text-center text-bold">
                    <td>گروه گالا</td>
                    <td :style="$q.screen.lt.md?'display:none':''">مبلغ کل</td>
                    <td>مبلغ دریافتی</td>
                    <td>باقیمانده</td>
                  </q-tr>
                  <q-tr class="text-center">
                    <td></td>
                    <td class="text-bold">{{ lodash.sumBy(items, 'SaleG_Pay').toLocaleString() }}</td>
                    <td class="text-bold">{{ lodash.sumBy(items, 'Sale_PayReceive').toLocaleString() }}</td>
                    <td class="text-bold">{{ lodash.sumBy(items, 'DiffSalePay').toLocaleString() }}</td>
                  </q-tr>
                </template>
                <template v-slot:body="props">
                  <q-tr :props="props" class="my-class">
                    <td>
                      <q-chip @click="showDetails(props.row)"
                              :dense="$q.screen.lt.md"
                              :label="props.row.Group_Name"
                              clickable square icon="category"/>
                    </td>
                    <td class="text-center" :style="$q.screen.lt.md?'display:none':''">
                      {{ props.row.SaleG_Pay.toLocaleString() }}
                    </td>
                    <td class="text-center">{{ props.row.Sale_PayReceive.toLocaleString() }}</td>
                    <td class="text-center">{{ props.row.DiffSalePay.toLocaleString() }}</td>
                  </q-tr>
                </template>
              </q-table>
            </q-card-section>
          </q-card>
        </div>
      </div>
    </q-card-section>
    <q-dialog :maximized="$q.screen.lt.md" v-model="detailsDialog">
      <GroupDetails :details="details" :group-name="selectedGroupName"/>
    </q-dialog>
  </q-card>
</template>

<script>
import {mapActions} from "vuex";
import GroupDetails from "@/components/Deboters/GroupDetails";

export default {
  name: "FinancialClaimsGoodsInfo",
  components: {GroupDetails},
  props: {
    items: {
      type: []
    },
    title: {
      type: String,
      required: true
    },
    passed: {
      type: Boolean,
      required: true
    },
    startDate: {
      type: String,
      required: true
    },
    endDate: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      selectedGroupName: '',
      detailsDialog: false,
      details: [],
      series: this.passed ? this.items.map(item => item.Sale_PayReceive) : this.items.map(item => item.DiffSalePay),
      chartOptions: {
        chart: {
          // events: {
          //   dataPointSelection: (event, chartContext, config) => {
          //     console.log(config.w.config.labels[config.dataPointIndex])
          //   }
          // },
          type: 'pie',
          fontFamily: "IRANSans, sans-serif",

        },
        dataLabels: {
          enabled: true,
        },
        labels: this.items.map(item => item.Group_Name),
        legend: {
          position: 'top',
          formatter: function (val) {
            return val.toLocaleString()
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val.toLocaleString()
            }
          }
        },
      },
    }
  },
  methods: {
    ...mapActions({
      getList: 'Dashboard/getListOfFinancialClaimsGoodsByGroupId'
    }),
    showDetails(row) {
      this.selectedGroupName = row.Group_Name
      this.getList({
        startDate: this.startDate,
        endDate: this.endDate,
        groupId: row.Group_ID
      }).then((res) => {
        this.details = res
        this.detailsDialog = true
      })
    }
  }
}
</script>

<style scoped>
</style>